import { render, staticRenderFns } from "./AdmissionDialog.vue?vue&type=template&id=20859511&scoped=true&lang=pug"
import script from "./AdmissionDialog.vue?vue&type=script&lang=js"
export * from "./AdmissionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20859511",
  null
  
)

export default component.exports